
import { Button } from '@/components/ui/button';
import { Mic } from 'lucide-react';

interface RolePlayButtonProps {
  isListening: boolean;
  onClick: () => void;
}

export const RolePlayButton = ({ isListening, onClick }: RolePlayButtonProps) => {
  return (
    <div className="max-w-2xl mx-auto mt-12 text-center">
      <Button
        size="lg"
        onClick={onClick}
        className={`${
          isListening ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-500 hover:bg-blue-600'
        } text-white rounded-full p-8 transition-all duration-200`}
      >
        <Mic className={`h-8 w-8 ${isListening ? 'animate-pulse' : ''}`} />
      </Button>
      <p className="mt-4 text-lg text-gray-600">
        {isListening ? 'Listening... Click to stop' : 'Click to start role playing'}
      </p>
    </div>
  );
};
